module.exports = __webpack_public_path__ + "media/reset.132e5d3f.mp3";